<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  tags: {
    type: Array,
    required: true
  }
});
</script>

<template>

    <!-- <span v-for="(tag, index) in tags" :key="index" class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
      {{ tag.title }}
    </span> -->
</template>
